import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import localForage = require("localforage");

import { SessionStorageService } from "./session-storage.service";
import { config } from "../../../../config/index";

@Injectable()
export class AuthResolver implements CanActivate {

    constructor(
        private _router: Router,
        private _sessionStorageService: SessionStorageService) { }

    /**
     * function to check if logged in. If not return to login page.
     * @returns Promise false if not logged In
     */
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        try {
            const isLoggedIn = sessionStorage.getItem('logined');
            const isToken = await this._sessionStorageService.readItem(config.storage_key);
            const userRole: any = await this._sessionStorageService.readItem(config.role);
            const subscription: any = await this._sessionStorageService.readItem(config.package);
            let roles = route.data["roles"] as Array<string>;
            let subscriptions = route.data["subscription"] as Array<string>;
            // Checking token
            if (!isLoggedIn && !isToken && !userRole.role && !subscription.package) {
                this._router.navigate(['login']);
                return false;
            }
            // Checking path wise authentication
            else {
                if (roles === undefined) {
                    return true;
                }
                else {
                    if (roles === null || roles.indexOf(userRole.role) === -1) {
                        this._router.navigate(['dashboard']);
                        return false;
                    }
                    else {
                        if (subscriptions !== undefined && (subscriptions === null || subscriptions.indexOf(subscription.package) === -1)) {
                            if (userRole.role === 'CT Admin') {
                                return true;
                            } else {
                                this._router.navigate(['dashboard']);
                                return false;
                            }
                        } else {
                            return true;
                        }
                    }
                }

            }
        }
        catch (error) {
            this._router.navigate(['logout']);
            return false;
        }
    }
}
